import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { notify } from "../../utils/toast";
import api from "../../api";

export const Dashboard = () => {
  const [loader, setLoader] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [data, setData] = useState({});

  const [activeEmp, setActiveEmp] = useState(0);
  const [inactiveEmp, setInactiveEmp] = useState(0);

  const getData = async () => {
    try {
      const response = await api.getDashboard();
      console.log(response);
      if (response?.success) {
        setData(response || {});
        setTableData(response?.recentStudents || []);
      }
    } catch (error) {
      notify.error("Something went wrong");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row analytics-row">
          <AnalyticsBox
            icon={<i className="fa-solid fa-users"></i>}
            title="Total Students"
            amount={data?.totalStudents}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user-check"></i>}
            title="Active Students"
            amount={data?.activeStudents}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-user-xmark"></i>}
            title="Inactive Students"
            amount={data?.inactiveStudents}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-calendar-plus"></i>}
            title="St. Joined Last Month"
            amount={data?.joinedLastMonth}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-calendar "></i>}
            title="Joined Last Year"
            amount={data?.joinedLastYear}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-road"></i>}
            title=" Total Routes"
            amount={data?.totalRoutes}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-route"></i>}
            title="Active Routes"
            amount={data?.activeRoutes}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-bus"></i>}
            title="Total Vehicles"
            amount={data?.totalVehicles}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-bus-simple"></i>}
            title="Active Vehicles"
            amount={data?.activeVehicles}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-id-card"></i>}
            title="Total Drivers"
            amount={data?.totalDrivers}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-circle-check"></i>}
            title="Active Drivers"
            amount={data?.activeDrivers}
          />
        </div>
        <div className="row">
          <div className="col">
            <h3>Recent Students</h3>
            <Table data={tableData ? tableData : []} />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
    </>
  );
};

function AnalyticsBox(props) {
  return (
    <div className="col-xl-3 col-md-6 mb-4">
      <div className="card h-100 py-2 border-transparent br-10 bg-gray1">
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col">
              {/* <img className="analytic-box-img" src={props.icon} alt="" /> */}
              <div className="analytic-box-img">{props.icon}</div>
            </div>
            <div className="col-auto mr-2">
              <div className="text-xs font-weight-bold  mb-1">
                <span className="analytics-box-title">{props.title}</span>
              </div>
              <div className="h3 mb-0 font-weight-bold text-gray-800">
                {props.amount}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Table = ({ data }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY");
    return dateTemp;
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col" className="">
                  Name
                </th>
                <th scope="col" className="">
                  Roll No.
                </th>
                <th scope="col" className="">
                  Assigned Route
                </th>
                <th scope="col" className="">
                  Assigned Vehicle
                </th>
                <th scope="col" className="">
                  Phone
                </th>
                <th scope="col" className="">
                  Status
                </th>
                <th scope="col" className="">
                  Fee Plan
                </th>
                <th scope="col" className="">
                  Fee
                </th>
                <th scope="col" className="">
                  Added At
                </th>
                <th scope="col" className=""></th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.name}
                    </div>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.rollNo}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.routeId?.name}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.vehicleId?.numberPlate}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.phone}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.status}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.feePlan}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.feeAmount}
                    </span>
                  </td>
                  <td scope="row" className="d-flex">
                    <div className="table-text-dark w-max-c db">
                      {item?.createdAt ? formatDate(item?.createdAt) : "-"}
                    </div>
                  </td>
                  {/* <td>
                    <Link
                      to={`/admin/employee/${item?._id}`}
                      className="p-2 cursor-pointer color-dark"
                    >
                      <i className="fa-solid fa-eye"></i>
                    </Link>{" "}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
